<template>
  <section  v-if="!isPDPstickyTab && isVisible" class="border-b border-gray-300 tab-section">
  <div class="m-auto max-w-[var(--max-w-container)] xl:max-w-[var(--max-w-container-xl)] 2xl:max-w-[var(--max-w-container-2xl)]">
    <ul class="flex">
      <li class="inline-block py-[1.0714rem] leading-none mr-[2.1429rem] hover:border-b-[0.1429rem] hover:border-ash-500 [&>a]:hover:text-ash-500">
        <NuxtLink :to="closerLookPageUrl" class="inline-block text-gray-700 font-normal" :aria-label="CONTENT_TYPES.CLOSERLOOKTEXT" :title="CONTENT_TYPES.CLOSERLOOKTEXT" id="closer-look" external>
          {{CONTENT_TYPES.CLOSERLOOKTEXT}}
        </NuxtLink>
      </li>
      <li class="inline-block py-[1.0714rem] leading-none text-ash-500 font-medium border-b-[0.1429rem] border-ash-500">
         {{CONTENT_TYPES.CLOSERLOOKBUYNOW}}
      </li>
    </ul>
  </div>
</section>
<section
    v-else-if="isPDPstickyTab && isStickyReady"
    ref="stickySection"
    class="border-b border-gray-300 tab-section sticky top-[164px] lg:top-[111px] z-30 bg-[#ffffff]"  :style="{top: `${stickyTop}px`}" >
    <!-- Sticky Wrapper -->
    <div
    class="relative m-auto max-w-[var(--max-w-container)] xl:max-w-[var(--max-w-container-xl)] 2xl:max-w-[var(--max-w-container-2xl)]"    
   >
      <button
        v-if="showBackToTop"
        class="absolute left-0 top-0 bottom-0 z-20 bg-white inline-flex items-center gap-2 py-[1.0714rem] leading-none pl-5 pr-4 text-gray-600 font-normal focus:text-ash-500 cursor-pointer shadow-[8px_0_8px_-8px_rgba(0,0,0,0.12)] lg:shadow-none lg:pl-0"
        @click="scrollToTop"
      >
        <Icon
          icon="arrow-up"
          class="h-4.42 w-4.42"
        />

        <span class="hidden lg:inline">
          {{ CONTENT_TYPES.CLOSERLOOKBACKTOTOP }}
        </span>
      </button>
      <div class="overflow-x-scroll lg:overflow-x-hidden whitespace-nowrap">
      <ul class="flex pr-[4rem] lg:pr-0" :class="showBackToTop ? 'pl-[4.5rem] lg:pl-[110px]' : 'pl-5'">
         <li
          v-for="tab in tabs"
          :key="tab.id"
          :ref="setTabRef(tab.id)"
          class="inline-block py-[1.0714rem] leading-none mr-[2.1429rem] last:pr-8 lg:last:pr-0"
           :class="[
              activeSection === tab.id
                ? 'border-b-[0.1429rem] border-ash-500'
                : 'border-transparent'
            ]"
        >         
           <button
            class="inline-block cursor-pointer transition-colors hover:text-ash-500 focus-visible:text-ash-500"
            :class="getTabClass(tab)"
            :aria-label="tab.label"
            :title="tab.label"
            @click="handleTabClick(tab.id)"
          >
            {{ tab.label }}
          </button>
        </li>
        <li
          v-if="hasCloserLookUrl"
          class="inline-block py-[1.0714rem] leading-none mr-[2.1429rem] focus-within:border-b-[0.1429rem] focus-within:border-ash-500 [&>a]:hover:text-ash-500 [&>a]:focus:text-ash-500 last:pr-8 lg:last:pr-0"
        >
          <NuxtLink
            :to="closerLookPageUrl"
            class="inline-block text-gray-600 font-normal focus:text-ash-500 cursor-pointer"
            :aria-label="CONTENT_TYPES.CLOSERLOOKTEXT"
            :title="CONTENT_TYPES.CLOSERLOOKTEXT"
          >
            {{ CONTENT_TYPES.CLOSERLOOKTEXT }}
          </NuxtLink>
        </li>
      </ul>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue'
import type { ComponentPublicInstance } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useIframeStore } from "@/stores/chatAIStore";
import { CONTENT_TYPES  } from '~~/shared/utils/contentTypes'
import { useUserStore } from '~/stores/userStore'
import { useStickyTabs } from "~/composables/useNavSticky"

import Icon from "~/components/ui/atom/icon.vue";

const props = defineProps<{
  closerLookPageUrl?: RouteLocationRaw
  isStickyReady?: boolean
  isTaiaSectionVisible ?: boolean
  isFaqSectionVisible ?:boolean

}>()

const isVisible = computed(() => {
  return !!props.closerLookPageUrl && props.closerLookPageUrl !== 'none'
})

const userStore = useUserStore()
const iframeStore = useIframeStore()
const { dynamicYieldData } = storeToRefs(iframeStore)

const isPDPstickyTab = computed(() => {
  const flag = dynamicYieldData.value?.PDPStickytab
  if (typeof flag === 'boolean') {
    return flag
  }
  return String(flag).toLowerCase() === 'true'
})



const {
  activeSection,
  scrollToSection,
  updateActiveSection
} = useStickyTabs()


const showBackToTop = ref(false)

const stickySection =
  ref<HTMLElement | null>(null)
    


const tabs = computed(() => {
  return [

    ...(props.isTaiaSectionVisible
      ? [{
          id: 'Aisummary-comparsion',
          label: CONTENT_TYPES.CLOSERLOOKTSUMMARY,
          gradient: true
        }]
      : []),

    {
      id: 'ingredients',
      label:
        CONTENT_TYPES.CLOSERLOOKINGREDIENTINFORMATION
    },

    {
      id: 'transcript-product-infosection',
      label: CONTENT_TYPES.CLOSERLOOKDETAILS
    },
    {
      id: 'warnings',
      label: CONTENT_TYPES.CLOSERLOOKWARNINGS
    },
  ...(
      props.isFaqSectionVisible
        ? [{
            id: 'Faqs',
            label: CONTENT_TYPES.CLOSERLOOKFAQS
          }]
        : []
    ),
    {
      id: 'reviews',
      label: CONTENT_TYPES.CLOSERLOOKREVIEWS
    }

  ]
})
const getTabClass = (
  tab: { gradient?: boolean; id: string }
) => {
  if (tab.gradient) {
    return 'bg-gradient-to-r from-[#6C69AD] via-[#A86361] to-[#6A2F29] bg-clip-text text-transparent font-medium'
  }

  return activeSection.value === tab.id
    ? 'text-ash-500 font-medium'
    : 'text-gray-600 font-normal'
}


const tabRefs = ref<Record<string, HTMLElement>>({})

const setTabRef = (id: string) => {
  return (
    el: Element | ComponentPublicInstance | null
  ) => {
    if (el instanceof HTMLElement) {
      tabRefs.value[id] = el
    }
  }
}

const isTabClickScrolling = ref(false)
const handleTabClick = async (
  id: string
) => {
  isTabClickScrolling.value = true

  await scrollToSection(id,  tabRefs.value[id])

  setTimeout(() => {
    isTabClickScrolling.value = false
  }, 800)
}
watch(activeSection, (id) => {
  if (!id) return

  if (isTabClickScrolling.value) {
    return
  }

  tabRefs.value[id]?.scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest'
  })
})


const stickyTop = computed(() => {
  return window.innerWidth >= 1024
    ? (userStore.loggedIn ? 102 : 111)
    : 164
})
const handleScroll = () => {
  updateActiveSection(
    tabs.value.map(tab => tab.id)
  )
  if (!stickySection.value) return
  const rect =
    stickySection.value.getBoundingClientRect()

  showBackToTop.value =
    rect.top <= stickyTop.value
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
const hasCloserLookUrl = computed(() => {
  return !!props.closerLookPageUrl
})
onMounted(() => {
  window.addEventListener('scroll',handleScroll)
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
